import { Canvas, useFrame } from "@react-three/fiber";
import React, { useRef } from "react";
import styleSheet from "./style.module.scss";
import { Html } from "@react-three/drei";
import ufo from "../../../../../asset/ufo.png";

type Props = {};

const SolarSystem = (props: Props) => {
  const Sphere = ({ position, size, color, onClick, value }: any) => {
    const ref = useRef<any>(null);
    useFrame((state, delta) => {
      if (ref.current) {

        console.log(Math.sin(state.clock.elapsedTime));
        
        // ref.current.rotation.x += delta;
        ref.current.position.x = Math.sin(state.clock.elapsedTime *1);
        ref.current.position.y = Math.cos(state.clock.elapsedTime *1);

        // ref.current.position.y = Math.sin(state.clock.elapsedTime) ;
        // ref.current.position.z += Math.sin(state.clock.elapsedTime) ;
      }
    });
    return (
      <mesh position={position} ref={ref} onClick={onClick}>
        <sphereGeometry args={size} />

        <meshStandardMaterial color={color} />
      </mesh>
    );
  };
  return (
    <div className={`${styleSheet.orbit_div} rounded-circle opacity-50 ms-5`}>
      <div className={`${styleSheet.orbit} position-relative rounded-circle`}>
        <div
          className={`h-75 w-75 ${styleSheet.sub_orbit} position-absolute rounded-circle top-50 start-50 translate-middle `}
        >
          <div
            className={`h-50 w-50 ${styleSheet.sub_orbit} position-absolute rounded-circle top-50 start-50 translate-middle`}
          >
            <Canvas className={`${styleSheet.frame}`}>
              <directionalLight position={[0, 0, 0.1]} />

              <Sphere
                position={[-2.4, 0, 0]}
                color={"#FFE26A"}
                size={[0.9, 40, 40]}
                value={"sun"}
              />
            </Canvas>
            <div
              className={`h-25 w-25 ${styleSheet.sub_orbit} position-absolute rounded-circle top-50 start-50 translate-middle`}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SolarSystem;
